// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-N":"N_outdoor-recreation-N__5_oaS"};